import { FC } from 'react'

import {
  Button,
  Cluster,
  Stack,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Typography,
} from '@forto-dev/phoenix-ui-core/common'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'
import { Navigation } from '@/fragments/navigation'
import { useLocalisation } from '@/utils/localisation'

import { Subscriptions } from './subscriptions/subscriptions'
import { Tokens } from './tokens/tokens'

export const Integrations: FC = () => {
  const { translate } = useLocalisation()

  return (
    <Layout
      header={<Header />}
      navigation={<Navigation />}
      title={
        <Cluster gap={8} x="between" y="center">
          <Typography variant="h4">{translate('integrations.title')}</Typography>
          <Button
            variant="outline-primary"
            onClick={() => window.open('https://developers.forto.com', '_blank', 'noopener,noreferrer')}
          >
            {translate('integrations.links.docs')}
          </Button>
        </Cluster>
      }
      main={
        <Tabs defaultValue="tokens">
          <Stack gap={16}>
            <TabsList>
              <TabsTrigger value="tokens">{translate('integrations.tabs.tokens')}</TabsTrigger>
              <TabsTrigger value="subscriptions">{translate('integrations.tabs.subscriptions')}</TabsTrigger>
            </TabsList>
            <Stack>
              <TabsContent value="tokens">
                <Tokens />
              </TabsContent>
              <TabsContent value="subscriptions">
                <Subscriptions />
              </TabsContent>
            </Stack>
          </Stack>
        </Tabs>
      }
      footer={<Footer />}
    />
  )
}
